export default __webpack_public_path__ + "static/media/Home.63d61f12.gif";